import {
    MAPIBANPROVIDER_SUCCESS,
    MAPIBANPROVIDER_FAILED,
    RESET_MAPIBANPROVIDER,
    LOADING_MAPIBANPROVIDER,
    NETWORK_ERROR_MAPIBANPROVIDER
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_MAPIBANPROVIDER:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: ""
            };
        case MAPIBANPROVIDER_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case MAPIBANPROVIDER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case NETWORK_ERROR_MAPIBANPROVIDER:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: ""
            };
        case RESET_MAPIBANPROVIDER:
            return (state = initialState);
        default:
            return state;
    }
};